var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#000","strokeLinecap":"square","transform":"rotate(45 20.536 7.964)"},[React.createElement("path",{"d":"M17,0.5 L17,32.21875","key":0}),React.createElement("path",{"d":"M17,0.5 L17,32.21875","transform":"rotate(-90 17 16.5)","key":1})]));
}

Close.defaultProps = {"width":"24","height":"23","viewBox":"0 0 24 23"};

module.exports = Close;

Close.default = Close;
